import { render, staticRenderFns } from "./ddt.vue?vue&type=template&id=1b49aec3"
import script from "./ddt.vue?vue&type=script&lang=js"
export * from "./ddt.vue?vue&type=script&lang=js"
import style0 from "./ddt.vue?vue&type=style&index=0&id=1b49aec3&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutsAppBar: require('/build/21d208aa-e762-4709-bc0c-59c523bce756/nuxt/components/Layouts/AppBar.vue').default,LayoutsHolidayBanner: require('/build/21d208aa-e762-4709-bc0c-59c523bce756/nuxt/components/Layouts/HolidayBanner.vue').default,VGlobalLoader: require('/build/21d208aa-e762-4709-bc0c-59c523bce756/nuxt/components/VGlobalLoader.vue').default,LayoutsFooter: require('/build/21d208aa-e762-4709-bc0c-59c523bce756/nuxt/components/Layouts/Footer.vue').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VApp,VCol,VContainer,VImg,VMain,VRow,VTab,VTabs})
